import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { useTranslation } from 'react-i18next';
import { EntryPoint } from '../../models';
import { TrackingUtils, withPageContext } from '../../utils';

const HotelSelectorInputDesktop = ({
    trackEvent,
    displayedWord,
    focus,
    hasError,
    onClickInput,
    onChangeInput,
    onRemoveFocus,
    isDisabled,
}) => {
    const { t } = useTranslation();
    const inputNode = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            const key = e.keyCode || e.key;
            if (key === 'Tab' || key === 9) {
                onRemoveFocus();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onRemoveFocus]);

    useEffect(() => {
        if (focus) {
            inputNode.current.focus();
        }
    }, [focus]);

    const getPlaceholderId = () => {
        const typeSearch = 'home.hsaSearch';
        const key = 'destination';
        return `${typeSearch}.${key}`;
    };

    const handleFocus = () => onClickInput();

    const handleChangeInput = (e) => {
        onChangeInput(e.target.value);
    };

    const handleTracking = (label) => {
        const action = TrackingUtils.ACTION.HOTELS;
        trackEvent({ action, label });
    };

    const handleClickInput = (e) => {
        e.target.select();
        const FIELD_NAME_TRACKING = 'dest';
        handleTracking(TrackingUtils.LABEL.fieldOpen(EntryPoint.HOTELS, FIELD_NAME_TRACKING));
        onClickInput();
    };

    const inputClassNames = className({
        'odf-z-index-2': hasError,
        'odf-input-inline-first': true,
    });
    const placeholder = t(getPlaceholderId());
    return (
        <input
            className={`odf-input-m odf-text-lg odf-input odf-input-inline odf-text-ellipsis ${inputClassNames}`}
            type="text"
            value={displayedWord}
            placeholder={placeholder}
            autoComplete="off"
            spellCheck="false"
            onChange={handleChangeInput}
            onClick={handleClickInput}
            onFocus={handleFocus}
            disabled={isDisabled}
            test-id="input-airport"
            data-testid="input-airport"
            ref={inputNode}
        />
    );
};

HotelSelectorInputDesktop.propTypes = {
    displayedWord: PropTypes.string.isRequired,
    onClickInput: PropTypes.func.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    onRemoveFocus: PropTypes.func.isRequired,
    focus: PropTypes.bool,
    hasError: PropTypes.bool,
    isDisabled: PropTypes.bool,
    trackEvent: PropTypes.func.isRequired,
};

HotelSelectorInputDesktop.defaultProps = {
    focus: false,
    hasError: false,
    isDisabled: false,
};

export default withPageContext(HotelSelectorInputDesktop);
